import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private storage: Storage | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.storage = localStorage;
    }
  }

  set(key: string, value: any): void {
    if (this.storage) {
      const encryptedValue = btoa(
        unescape(encodeURIComponent(JSON.stringify(value)))
      );
      this.storage.setItem(key, encryptedValue);
    }
  }

  get(key: string): any {
    if (this.storage) {
      const res = this.storage.getItem(key);
      if (res) {
        const decrypted = decodeURIComponent(escape(atob(res)));
        return JSON.parse(decrypted);
      }
    }
    return null;
  }

  removeItem(key: string): void {
    if (this.storage) {
      this.storage.removeItem(key);
    }
  }

  clear(): void {
    if (this.storage) {
      this.storage.clear();
    }
  }
}
